import useToken from 'hooks/useToken';
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useToast } from 'context/providers/ToastProvider';
import FalconCloseButton from 'components/common/FalconCloseButton';
import { Badge, Button, Col, Form, InputGroup, Modal, Row, Spinner, ButtonGroup } from "react-bootstrap";
import { FaBox, FaSearch, FaShoppingCart, FaTimes } from 'react-icons/fa';
import ProductoTarjeta from './ProductoTarjeta';

const ModalProductos = (
    {
        mostrarModal,
        setMostrarModal,
        ObtenerProductoPorID,
        productosAgregados
    }

) => {
    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();
    const [productos, setProductos] = useState([]);
    const [productosFiltrados, setProductosFiltrados] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [agregando, setAgregando] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [monedaSeleccionada, setMonedaSeleccionada] = useState("MXN");


    useEffect(() => {
        if (mostrarModal) {
            ObtenerProductos();
        }
    }, [mostrarModal]);

    useEffect(() => {
        // Filtrar productos cuando cambia el término de búsqueda o la moneda seleccionada
        let filtered = productos.filter(producto => producto.vMoneda === monedaSeleccionada);

        if (searchTerm.trim() !== "") {
            filtered = filtered.filter(producto =>
                producto.vNombreProducto?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                producto.vCodigoBarras?.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }
        setProductosFiltrados(filtered);
    }, [searchTerm, monedaSeleccionada, productos]);


    /**
    * Obtiene productos
    */
    const ObtenerProductos = async () => {
        setCargando(true);

        const response = await fetch("/api/contabilidad/facturas/FormularioFactura/ObtenerProductos",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response?.ok) {
            setCargando(false);
            console.log("==== OBTENER PRODUCTOS ====");

            const data = await response.json();
            console.log("dataPDCS: ", data);

            if (data.iResponseType == 1) {
                var ObjDetalles = JSON.parse(data.detalles);
                console.log("ObjDetallesPD:", ObjDetalles);
                setProductos(ObjDetalles.table2);
                setProductosFiltrados(ObjDetalles.table2);
            } else {
                
                showErrorToast(data.vMessage);
            }

        }
        else {
            setCargando(false);
            
            showErrorToast(response?.status + ' ' + response?.statusText);
            if (response?.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
     * Agregar producto al carrito
     */
    const handleAgregarProducto = async (idProducto, idProductoPrecio) => {
        setAgregando(idProducto);
        try {
            await ObtenerProductoPorID(idProducto, idProductoPrecio);
        } finally {
            setAgregando(null);
        }
    };

    /**
     * Verificar si un producto ya fue agregado
     */
    const yaAgregado = (idProducto, idProductoPrecio) => {
        return productosAgregados.some(prod => prod.idProducto === idProducto && prod.idProductoPrecio === idProductoPrecio);
    };

    return (
        <Modal
            show={mostrarModal}
            onHide={() => setMostrarModal(false)}
            size="xl"
            backdrop="static"
            aria-labelledby="modal-seleccionar-producto"
            centered
            scrollable
        >
            <Modal.Header className="bg-primary text-white border-0 px-4 py-3">
                <div className="w-100">
                    <div className="d-flex justify-content-between align-items-center">
                        <Modal.Title id="modal-seleccionar-producto" className="text-white fs-1 fw-semi-bold">
                            <FaShoppingCart className="me-2" />
                            Seleccionar Producto
                        </Modal.Title>
                        <FalconCloseButton
                            className="btn btn-circle btn-sm transition-base p-0"
                            onClick={() => { setMostrarModal(false); }}
                            white
                        />
                    </div>

                    {/* Barra de búsqueda y toggle de moneda en el header */}
                    <div className="mt-3 d-flex flex-column flex-sm-row justify-content-between align-items-sm-center gap-2">
                        <InputGroup className="flex-grow-1">
                            <InputGroup.Text className="bg-white border-end-0">
                                <FaSearch style={{ color: '#009bdb' }} />
                            </InputGroup.Text>
                            <Form.Control
                                type="text"
                                placeholder="Buscar por nombre o código de barras..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="border-start-0 fs--1"
                            />
                            {searchTerm && (
                                <Button
                                    variant="light"
                                    onClick={() => setSearchTerm("")}
                                    className="border-start-0"
                                >
                                    <FaTimes />
                                </Button>
                            )}
                        </InputGroup>
                        <div className="d-flex align-items-center">
                            <ButtonGroup size="sm">
                                <Button
                                    variant={monedaSeleccionada === 'MXN' ? 'primary' : 'falcon-default'}
                                    onClick={() => setMonedaSeleccionada('MXN')}
                                >
                                    MXN
                                </Button>
                                <Button
                                    variant={monedaSeleccionada === 'USD' ? 'primary' : 'falcon-default'}
                                    onClick={() => setMonedaSeleccionada('USD')}
                                >
                                    USD
                                </Button>
                            </ButtonGroup>
                        </div>
                    </div>

                    {/* Información de resultados */}
                    <div className="mt-2 d-flex justify-content-between align-items-center">
                        <small className="text-white-50">
                            {productosFiltrados.length} producto{productosFiltrados.length !== 1 ? 's' : ''} encontrado{productosFiltrados.length !== 1 ? 's' : ''}
                        </small>
                        <Badge bg="200" className="text-800 fs--2 fw-semi-bold border border-300">
                            {productosAgregados.length} agregado{productosAgregados.length !== 1 ? 's' : ''}
                        </Badge>
                    </div>
                </div>
            </Modal.Header>

            <Modal.Body
                className="bg-body-tertiary px-4 py-3"
                style={{
                    minHeight: '500px',
                    maxHeight: '600px',
                }}
            >
                {cargando ? (
                    <div className="text-center py-5">
                        <Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} />
                        <p className="mt-3 text-800">Cargando productos...</p>
                    </div>
                ) : productosFiltrados.length === 0 ? (
                    <div className="text-center py-5">
                        <FaBox size={60} className="mb-3 text-400" />
                        <h5 className="text-muted">No se encontraron productos</h5>
                        <p className="text-500 small">
                            {searchTerm ? 'Intenta con otro término de búsqueda' : 'No hay productos disponibles'}
                        </p>
                    </div>
                ) : (
                    <Row className="g-3">
                        {productosFiltrados.map((producto) => (
                            <Col key={producto.idProductoPrecio || producto.idProducto} xs={12} sm={6} md={4} lg={3}>
                                <ProductoTarjeta
                                    producto={producto}
                                    agregado={yaAgregado(producto.idProducto, producto.idProductoPrecio)}
                                    cargandoEsteProducto={agregando === producto.idProducto}
                                    onAgregarProducto={(idProd) => handleAgregarProducto(idProd, producto.idProductoPrecio)}
                                />
                            </Col>
                        ))}
                    </Row>
                )}
            </Modal.Body>

            <Modal.Footer className="bg-body-tertiary border-top border-200 px-4 py-3">
                <div className="d-flex justify-content-between align-items-center w-100">
                    <div>
                        <span className="text-800 fs--1">
                            Total de productos: <strong>{productos.length}</strong>
                        </span>
                    </div>
                    <Button
                        variant="falcon-default"
                        size="sm"
                        onClick={() => setMostrarModal(false)}
                    >
                        <FaTimes className="me-2" />
                        Cerrar
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

ModalProductos.propTypes = {
    mostrarModal: PropTypes.bool.isRequired,
    setMostrarModal: PropTypes.func.isRequired,
    ObtenerProductoPorID: PropTypes.func.isRequired,
    productosAgregados: PropTypes.array
};

export default ModalProductos;